import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Download } from 'lucide-react';
import '../styles/Header.css';

const Header = ({ activeSection }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };


  return (
    <header className={`main-header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-content">
        <div className="logo" onClick={() => scrollToSection('home')}>
          <span className="logo-text">BB</span>
        </div>
        
        <nav className="nav-links">
          <button
            className={`nav-link ${activeSection === 'home' ? 'active' : ''}`}
            onClick={() => scrollToSection('home')}
          >
            About
          </button>
          <button
            className={`nav-link ${activeSection === 'services' ? 'active' : ''}`}
            onClick={() => scrollToSection('services')}
          >
            Services
          </button>
          <button
            className={`nav-link ${activeSection === 'skills' ? 'active' : ''}`}
            onClick={() => scrollToSection('skills')}
          >
            Skills
          </button>
          <button
            className={`nav-link ${activeSection === 'projects' ? 'active' : ''}`}
            onClick={() => scrollToSection('projects')}
          >
            Projects
          </button>
          <button
            className={`nav-link ${activeSection === 'certifications' ? 'active' : ''}`}
            onClick={() => scrollToSection('certifications')}
          >
            Certifications
          </button>
          <button
            className={`nav-link ${activeSection === 'contact' ? 'active' : ''}`}
            onClick={() => scrollToSection('contact')}
          >
            Contact
          </button>
        </nav>

        <Button asChild className="cv-button">
          <a
            href="/assets/Berkant_Bicakci_CV.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Download className="h-4 w-4" />
            <span>Download CV</span>
          </a>
        </Button>
      </div>
    </header>
  );
};

export default Header;
